<template lang="html">
    <li class="reminderItem" v-if="!editOpen">
        <span class="title">{{ reminder.title }}</span>
        <chevron-down-icon
            style="color: #257961"
            @click.prevent="open = !open"
            class="icon"
        ></chevron-down-icon>

        <div v-if="open" class="notes">
            {{ reminder.notes }}

            <div v-if="type == 'pro'" class="buttons">
                <button
                    @click.prevent="editOpen = true"
                    class="button half dark"
                    type="button"
                    name="button"
                >
                    Edit
                </button>
                <button
                    @click.prevent="deleteReminder"
                    class="button half red"
                    type="button"
                    name="button"
                >
                    Delete
                </button>
            </div>
        </div>
    </li>
    <add-edit-reminder
        v-else
        :reminder="reminder"
        @formOpen="formOpening"
        @formClosed="formClosing"
        @reminderUpdated="updateReminder"
    />
</template>

<script>
import AddEditReminder from "@/views/Pro/Players/Player/partials/add-edit-reminder";
import { ChevronDownIcon } from "vue-feather-icons";
export default {
    name: "reminder-item",
    components: { AddEditReminder, ChevronDownIcon },
    props: {
        reminder: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: "player",
        },
    },
    data() {
        return {
            open: false,
            editOpen: false,
        };
    },
    methods: {
        formOpening() {
            this.$emit("formOpen");
        },
        formClosing() {
            this.editOpen = false;
            this.$emit("formClosed");
        },
        updateReminder(reminder) {
            this.$emit("updateReminder", reminder);
        },
        deleteReminder() {
            this.$confirm("Are you sure you want to delete this key reminder?", () => {
                window.axios.delete("/reminder/" + this.reminder.id).then(() => {
                    this.$notify({
                        text: "Key reminder deleted",
                    });
                    this.$emit("reminderDeleted", this.reminder);
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.reminderItem {
    .title {
        font-size: 16px;
    }
    .notes {
        margin: 20px 0px;
        white-space: pre-line;
        color: $green_0;
        line-height: 1.5;
        font-weight: 200;
    }
    .buttons {
        margin-top: 20px;
    }
}
</style>
